import { Component, Input} from '@angular/core';
import {QuestionConfig, QuestionViewType} from '../../interfaces/process-config.interface';
import { BaseClass } from '../../classes/base';
import { ToastController } from '@ionic/angular';
import { TranslationService } from '../../services/translation.service';
import { SelfEvaluationRecord } from 'src/app/self-evaluation/_interfaces/self-evaluation-record.interface';

@Component({
  selector: 'app-question-answer',
  templateUrl: './question-answer.component.html',
  styleUrls: [ './question-answer.component.scss' ]
})
export class QuestionAnswerComponent extends BaseClass {

  @Input() question: QuestionConfig;
  @Input() evaluation: SelfEvaluationRecord;
  @Input() answer: any;

  @Input() groupIndex?: number = null;
  @Input() managerAnswer: boolean = false;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService
  ) {
    super(_toastController, _translationService);
  }

  protected readonly QuestionViewType = QuestionViewType;
}
